<template>
    <div class="container">
      <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
        :current='page' :count='count'>
        <div slot="queryParams" class="form">
          <div class="queryContainer">
            <div class="queryItem">
              <label>月份:</label>
              <timeStampDatePicker  v-model='query.month' class="item" type="month"></timeStampDatePicker>
            <div class="queryItem">
          </div>
            </div>
            <div class="queryItem">
              <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
              <lk-button @click="clear">重置</lk-button>
            </div>
          </div>
        </div>
        <div slot="table">
          <lk-menu width='100%' mode="horizontal" active-name='1' @on-select='handleSelected'>
            <lk-menu-item v-for="item in menu" :key='item.index' :name='item.index'>
                {{item.name}}
            </lk-menu-item>
          </lk-menu>
          <lk-table class="top10" border :columns='columns' :data='tableData'></lk-table>
        </div>
      </QueryFrame>
    </div>
  </template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import queryMixins from '@/mixins/queryMixins';
import tools from '@/services/tools';
import utils from '@/libs/utils';
import download from '../../services/download';

export default {
  name: 'timingExport',
  mixins: [queryMixins],
  components: {
    QueryFrame,
  },
  computed: { },
  data() {
    return {
      statusMap: new Map([
        [1, '导出中...'],
        [2, '完成'],
        [3, '已失效'],
      ]),
      menu: [
        {
          index: '1',
          name: '月末库存',
        },
        {
          index: '2',
          name: '月末应收预收',
        },
      ],
      columns: [
        {
          title: '序号',
          key: 'index',
          width: 80,
          type: 'index',
        },
        {
          title: '文件名',
          key: 'fileName',
          minWidth: 136,
        },
        {
          title: '月份',
          key: 'month',
          minWidth: 116,
        },
        {
          title: '生成时间',
          minWidth: 136,
          render: (h, { row }) => h('span', utils.exchangeTimeToSecond(row.createTime)),
        },
        {
          title: '导出进度',
          key: 'status',
          minWidth: 116,
          render: (h, { row }) => h('span', this.statusMap.get(row.status)),
        },
        {
          title: '下载次数',
          key: 'downloadCount',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.status !== 2,
              },
              on: {
                click: () => {
                  this.downloadFile(row);
                },
              },
            }, '下载'),
          ]),
        },
      ],
      query: {
        type: 1, // 查询维度
      },
      tableData: [],
    };
  },
  methods: {
    // handleSearch() {
    //   this.page = 1;
    //   this.size = 20;
    //   this.getData();
    // },
    handleSelected(val) {
      this.query.type = val;
      this.handleSearch();
    },
    clear() {
      utils.objInit(this.query, 'type');
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      return temp;
    },
    getData() {
      const params = this.formatParams(this.query); // 请求参数添加page，size
      tools.getTimingList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
          this.tableData.forEach((item) => {
            item.downloadCount = item.downloadCount || 0;
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    downloadFile(row) {
      download.downloadFile({ id: row.id }).then((res) => {
        utils.downLoadExcel(res, row.fileName, true);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less">
  .ivu-select-dropdown {
    z-index: 1000;
  }
  .ivu-menu {
    z-index: 0;
  }
  .top10 {
    margin-top: 10px;
  }
</style>
